import React, {Component} from 'react';
import ShowOptionalLabel from '../ShowOptionalLabel'
import LoadingFrame from '../LoadingFrame'
import ShowOptionalField from '../ShowOptionalField'
import PropTypes from 'prop-types';
class OrgMiniView extends Component {

    render() {
        let item = this.props.item;
        if (item === undefined || item === null) return null;
        let name = null;
        if (this.props.showName) {
            name = <div className="header">
                {item.name}
            </div>
        }
        return <div>
            {name}
            <div className="sub header">
                {item.indirizzo} {item.cap} {item.citta} {item.provincia} {item.stato}
                <ShowOptionalField label="P.IVA" value={item.piva}/> <ShowOptionalField label="C.Fisc." value={item.cfisc}/>
            </div>
            <div className="sub header">
                <ShowOptionalLabel title="Telefono 1" value={item.telefono1} icon="voulme control phone" extraClassName="left floated"/>
                <ShowOptionalLabel title="Telefono 2" value={item.telefono2} icon="voulme control phone" extraClassName="left floated"/>
                <ShowOptionalLabel title="FAX"        value={item.fax} icon="fax" extraClassName="left floated"/>
                <ShowOptionalLabel title="e-mail"     value={item.email} icon="mail" extraClassName="left floated"/>
                <ShowOptionalLabel title="PEC"        value={item.pec} icon="mail" extraClassName="left floated"/>
                <ShowOptionalLabel title="Sito web"   value={item.web} icon="world" extraClassName="left floated"/>
            </div>
            <div className="content">
                <i>{item.note}</i>
            </div>
            <LoadingFrame visible={this.props.loading} dim="tiny" testo=""/>
        </div>
    }
}

OrgMiniView.PropTypes = {
    item: PropTypes.object,
    loading: PropTypes.bool,
    showName: PropTypes.bool,
};

OrgMiniView.defaultProps = {
    loading: false,
    showName: false
};


export default OrgMiniView;


/** WEBPACK FOOTER **
 ** ./src/components/rubrica/OrgMiniView.js
 **/